var _rect, _rect2, _rect3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForms1C12B(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 48,
    viewBox: "0 0 168 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 48,
    rx: 5.17736,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.76599,
    y: 3,
    width: 42.7132,
    height: 42.7132,
    rx: 21.3566,
    fill: "#7E7E7E",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6553,
    y: 12.8893,
    width: 22.9349,
    height: 22.9349,
    rx: 11.4675,
    stroke: "#9394A8",
    strokeWidth: 1.65753
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.6064 29.6494V28.0228H53.6835V17.1141H51.9509V29.6494H59.6064ZM60.7181 27.3687C60.7181 28.7124 61.8319 29.9146 63.5646 29.9146C65.0851 29.9146 65.9338 29.1013 66.3051 28.5002C66.3051 29.119 66.3581 29.4373 66.3935 29.6494H68.02C67.9847 29.4373 67.914 28.9952 67.914 28.2527V23.9917C67.914 22.3298 66.9239 20.88 64.3779 20.88C62.5392 20.88 61.0717 22.0115 60.8949 23.6381L62.4861 24.0094C62.5922 23.0193 63.2464 22.2944 64.4133 22.2944C65.7039 22.2944 66.252 22.9839 66.252 23.8149C66.252 24.1155 66.1106 24.3807 65.5978 24.4514L63.2994 24.7873C61.8319 24.9995 60.7181 25.8482 60.7181 27.3687ZM63.7945 28.5179C62.9458 28.5179 62.4154 27.9167 62.4154 27.2803C62.4154 26.52 62.9458 26.1134 63.653 26.0073L66.252 25.6183V26.0073C66.252 27.8637 65.1558 28.5179 63.7945 28.5179ZM72.1826 29.6494V28.4118C72.7131 29.3312 73.6855 29.8793 74.9408 29.8793C77.4691 29.8793 78.9012 27.8814 78.9012 25.3531C78.9012 22.8779 77.5751 20.8977 74.9938 20.8977C73.5794 20.8977 72.5893 21.5872 72.1826 22.3475V16.8489H70.5384V29.6494H72.1826ZM77.2039 25.3531C77.2039 27.1919 76.2138 28.3941 74.6933 28.3941C73.2258 28.3941 72.165 27.1919 72.165 25.3531C72.165 23.5144 73.2258 22.3651 74.6933 22.3651C76.2314 22.3651 77.2039 23.5144 77.2039 25.3531ZM82.2383 24.5221C82.309 23.426 83.1577 22.3475 84.5544 22.3475C86.0573 22.3475 86.8529 23.3022 86.8882 24.5221H82.2383ZM87.1358 26.7322C86.8175 27.6869 86.128 28.4472 84.7489 28.4472C83.3168 28.4472 82.2206 27.3863 82.1853 25.8658H88.5855C88.6032 25.7597 88.6209 25.5476 88.6209 25.3354C88.6209 22.6834 87.1534 20.88 84.5368 20.88C82.3974 20.88 80.4703 22.7011 80.4703 25.3708C80.4703 28.2527 82.4682 29.9146 84.7489 29.9146C86.7291 29.9146 88.0905 28.73 88.5679 27.2272L87.1358 26.7322ZM92.3669 29.6494V16.8489H90.705V29.6494H92.3669Z",
    fill: "#14121D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms1C12B);
export default __webpack_public_path__ + "static/media/forms1c12b.19c052e924981b51f18837da2451ee82.svg";
export { ForwardRef as ReactComponent };